import { createTheme } from "@mui/material";
import ProviderUtils from "./utils/provider.utils";
import Provider from "./enum/Provider.enum";
import { grey } from "@mui/material/colors";
import { arSD, ruRU, trTR, hyAM } from "@mui/x-data-grid/locales";
import {
  arSD as coreArSD,
  ruRU as coreRuRU,
  trTR as coreTrTR,
  hyAM as coreHyAM,
} from "@mui/material/locale";

const provider = ProviderUtils.getProvider();
export let brandColor = "#6bb340";
export let brandColorBg = "#F2FFEE";
let themeOptions = {};

themeOptions.components = {
  MuiCssBaseline: {
    styleOverrides: {
      body: {
        backgroundColor: "rgba(196, 196, 196, 0.1)",
        margin: "0 auto",
        minHeight: "100vh",
      },
      '.MuiDataGrid-cell .MuiDataGrid-booleanCell[data-value="true"]': {
        color: "#6bb340 !important",
      },
    },
  },
  // Name of the component
  MuiButtonBase: {
    styleOverrides: {
      root: {
        borderRadius: "4px",
        textTransform: "none",
      },
    },
    defaultProps: {
      // The props to change the default for.
      //disableRipple: true, // No more ripple, on the whole application 💣!
      //disableElevation: true
    },
  },
  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: "4px",
        textTransform: "none",
        variants: [
          {
            props: { variant: "contained", color: "primary" },
            style: {
              color: "white",
            },
          },
        ],
      },
    },
    defaultProps: {
      disableElevation: true,
    },
  },
};

themeOptions.typography = {
  fontFamily: [
    "Good Pro",
    "Roboto",
    '"Helvetica Neue"',
    "Arial",
    "sans-serif",
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(","),
};

switch (provider) {
  case Provider.TFOS:
  case "za":
    brandColor = "#2E247E";
    brandColorBg = "#BFD7EA";

    themeOptions.palette = {
      primary: {
        main: brandColor,
        light: "#508CA4",
        dark: "#251D66",
      },
      success: {
        main: "#4F9D3A",
        light: "#4F9D3A",
      },
      secondary: {
        main: "#508CA4",
      },
      text: {
        primary: "#1A1A18",
      },
    };
    break;
  case Provider.BELARUS:
  case "by":
    brandColor = "#0099FF";
    brandColorBg = "#F5F5F8";

    themeOptions.palette = {
      primary: {
        main: brandColor,
        light: brandColor,
        dark: brandColor,
      },
      success: {
        main: "#4F9D3A",
        light: "#4F9D3A",
      },
      secondary: {
        main: grey.A700,
      },
    };
    break;
  case Provider.ARMENIA:
  case "am":
    themeOptions.palette = {
      primary: {
        main: brandColor,
        light: brandColor,
        dark: brandColor,
      },
      success: {
        main: "#4F9D3A",
        light: "#4F9D3A",
      },
      secondary: {
        main: grey.A700,
      },
    };
    break;
  default:
    themeOptions.palette = {
      primary: {
        main: brandColor,
        light: brandColor,
        dark: brandColor,
      },
      success: {
        main: "#4F9D3A",
        light: "#4F9D3A",
      },
      secondary: {
        main: grey.A700,
      },
    };
}

const LOCALE_ARGS_BY_LANGUAGE = {
  ar: [arSD, coreArSD],
  ru: [ruRU, coreRuRU],
  tr: [trTR, coreTrTR],
  hy: [hyAM, coreHyAM],
};

export const createAppTheme = (direction = "ltr", language = "ru") =>
  createTheme(
    { ...themeOptions, direction },
    ...(LOCALE_ARGS_BY_LANGUAGE[language] ?? []),
  );

const theme = createAppTheme("ltr", "ru");

export default theme;
